<template>
<div class="address_container">
  <div class="header_container">
    <h3>{{ $t('editAddAddress') }}</h3>
  </div>
  <div class='address_body_container'>
    <div class="title" @click="newAddressAdd">
      <i class="el-icon-plus"></i><span>{{ $t('addNewAddress') }}</span>
    </div>
    <div class="address_list">
      <div>
        <el-dialog v-bind:title="$t('addressRegistration')" :visible.sync="dialogVisible" class="modal">
          <el-form ref="addressForm" :rules="rules" :model="addressForm">
            <div class="fieldset">
              <div class="field">
                <div v-if="errorSubmitting" class="time_tip"><span>{{ $t('correctErrors') }}</span></div>
                <!--地址信息-->
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div class="width">
                      <el-form-item
                        prop="FirstName"
                        v-bind:label="$t('firstName')"
                      >
                        <el-input
                          v-bind:placeholder="$t('firstName')"
                          v-model="addressForm.FirstName"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="width">
                      <el-form-item
                        prop="LastName"
                        v-bind:label="$t('lastName')"
                      >
                        <el-input
                          v-bind:placeholder="$t('lastName')"
                          v-model="addressForm.LastName"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <div>
                      <el-form-item
                        prop="AddressName"
                        v-bind:label="$t('companyName')"
                      >
                        <el-input
                          v-bind:placeholder="$t('companyName')"
                          v-model="addressForm.AddressName"
                        ></el-input>
                      </el-form-item>
                      </div>
                    </el-col>
                  <el-col :span="12">
                    <div class="width">
                      <el-form-item
                        prop="Telephone"
                        v-bind:label="$t('phoneNumber')"
                      >
                        <el-input
                          v-bind:placeholder="$t('phoneNumber')"
                          v-model="addressForm.Telephone"
                          @input="phoneXPOFormatter(addressForm.Telephone)"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item
                      prop="Residential"
                      v-bind:label="$t('Residential')"
                    >
                      <el-radio-group v-model="addressForm.Residential">
                        <el-radio :label="true">Yes</el-radio>
                        <el-radio :label="false">No</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <div class="input_box" style="display: flex">
                  <span style="color:black">{{ $t("country") }} &nbsp;&nbsp;</span>
                  <el-radio v-model="addressForm.Country" label="US">{{ $t("usa") }}</el-radio>
                  <el-radio v-model="addressForm.Country" label="CN">{{ $t("canada") }}</el-radio>
                </div>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item
                      prop="Street"
                      v-bind:label="$t('street')"
                    >
                      <el-input
                        v-bind:placeholder="$t('street')"
                        v-model="addressForm.Street"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <div class="width">
                      <el-form-item prop="City" v-bind:label="$t('city')">
                        <el-input
                          v-bind:placeholder="$t('city')"
                          v-model="addressForm.City"
                        ></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <div v-if="addressForm.Country==='US'">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item prop="State" v-bind:label="$t('state')">
                        <el-select
                          v-model="addressForm.State"
                          v-bind:placeholder="$t('pleaseSelect')"
                          value=""
                        >
                          <el-option
                            v-for="item in stateOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <div class="width">
                        <el-form-item prop="Zip" v-bind:label="$t('zipCode')">
                          <el-input v-bind:placeholder="$t('zipCode')" v-model="addressForm.Zip" ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div v-else>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item prop="State" v-bind:label="$t('state')">
                        <el-select
                          v-model="addressForm.State"
                          v-bind:placeholder="$t('pleaseSelect')"
                          value=""
                        >
                          <el-option
                            v-for="item in caStateOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <div class="width">
                        <el-form-item prop="Zip" v-bind:label="$t('zipCode')">
                          <el-input v-bind:placeholder="$t('zipCode')" v-model="addressForm.Zip" ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                
                <span class="end" slot="footer">
                  <!-- <button class="btnCancel" @click="handleClose($event)">{{ $t('cancel') }}</button> -->
                  <button class="btn" :class="submitting? 'greybackground' : ''" @click="onSubmit($event, addressForm)">{{ $t('submit') }}</button>
                </span>
              </div>
            </div>
          </el-form>
        </el-dialog>
      </div>
      <div>
        <div style="marginBottom: 1em" class="address-container" v-if="addresses.length > 0">
          <ul>
            <li style="margin: 0.2em" v-for="(address, index) in addresses" :key="index">
              <span class="addressDisplay">{{ address.Street }}</span>
              <span>{{ address.City + ', ' + address.State + ' ' + address.Zip}}</span>
              <span class="deleteBtn" @click="editAddressModalOpen(address)"><i class="el-icon-edit"></i></span>
              <span class='editBtn' @click="openConfirmationDeleteAlert(address.CustomerDetail_id)"><i class="el-icon-delete"></i></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'
import {
  MessageBox
} from 'element-ui';
export default {
  name: 'account-address',
  data() {
    return {
      dialogVisible: false,
      errorSubmitting: false,
      submitting: false,
      addressForm: {
        FirstName: '',
        LastName: '',
        Residential: true,
        Street: '',
        City: '',
        Zip: '',
        Country: 'United States',
        State: '',
        AddressName: '',
        Telephone: '',
      },
      stateOptions: this.$store.state.addresses.states,
      caStateOptions:  this.$store.state.addresses.ca_states,
    }
  },
  // computed: {
  computed: mapState({
    addresses: state => state.addresses.billingAddresses, // state.addresses.customerDetails
    rules(){
      return {
        FirstName: [{
            required: true,
            message: this.$t('firstNameRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: this.$t('firstNameLengthRequired'),
            trigger: 'blur'
          }
        ],
        LastName: [{
            required: true,
            message: this.$t('lastNameRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: this.$t('lastNameLengthRequired'),
            trigger: 'blur'
          }
        ],
        Street: [{
            required: true,
            message: this.$t('addressRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 30,
            message: this.$t('addressNumberLengthRequired'),
            trigger: 'blur'
          }
        ],
        City: [{
            required: true,
            message: this.$t('cityRequired'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 20,
            message: this.$t('cityLengthRequired'),
            trigger: 'blur'
          }
        ],
        Zip: [{
            required: true,
            message: this.$t('zipCodeRequired'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 5,
            message: this.$t('zipCodeLengthRequired'),
            trigger: 'blur'
          }
        ],
        Country: [{
            required: true,
            message: this.$t('countryRequired'),
            trigger: 'blur'
          },
          {
            min: 2,
            max: 20,
            message: this.$t('countryLengthRequired'),
            trigger: 'blur'
          }
        ],
      }
    }
  }),
methods: {
  ...mapActions('addresses', ['fetchAddresses', 'postAddress', 'deleteAddress', 'editAddress']),
  resetForm() {
    this.addressForm = {
      FirstName: '',
      LastName: '',
      Residential: true,
      Street: "",
      City: '',
      Zip: '',
      State: '',
      Country: 'United States',
      AddressName: "",
      Telephone: '',
    }
  },
  openAlert() {
    this.$alert('You have successfully added a new address', 'Success', {
      confirmButtonText: 'OK',
      type: 'success',
      center: true
    }).then(() => {
      this.dialogVisible = false;
    }).catch(() => {});
  },
  openEditSuccessAlert() {
    this.$alert('An address has been modified', 'Success', {
      confirmButtonText: 'OK',
      type: 'success',
      center: true
    }).then(() => {
      this.dialogVisible = false;
    }).catch(() => {});
  },
  openConfirmationDeleteAlert(id) {
    MessageBox.confirm('Remove this address from the list?', 'Warning', {
      confirmButtonText: 'OK',
      cancelButtonText: 'CALCEL',
      type: 'warning',
      center: true
    }).then(() => {
      this.deleteAddress(id);
    }).catch(() => {});
  },
  handleClose(event) {
    event.preventDefault();
    this.resetForm();
    this.submitting = false;
    this.$refs['addressForm'].clearValidate();
    this.dialogVisible = false;
  },
  phoneXPOFormatter(value) {
    // NNN-NNNNNNN
    var cleaned = ('' + value).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    
    if (match) {
      this.addressForm.Telephone = match[1] + '-' + match[2] + match[3];
      // return match[1] + '-' + match[2] + match[3];
    }
  },
  onSubmit(event, address) {
    if (this.submitting) { return; }
    event.preventDefault();
    this.$refs['addressForm'].validate((valid) => {
      if (!valid) {
        return;
      } else {
        this.submitting = true
        if (address.CustomerDetail_id) {
          this.editAddress([address, address.CustomerDetail_id])
          .then(res => {
            this.openEditSuccessAlert();
            this.fetchAddresses();
            this.submitting = false;
          })
          .catch(err => {
            alerrt(err)
          })
        } else {
          this.postAddress(address)
          .then((res) => {
            this.openAlert();
            this.resetForm();
            this.submitting = false;
            this.$refs['addressForm'].clearValidate();
            this.fetchAddresses();
          })
         .catch(err => {
           alert(err);
         })
       }
     }
    });
  },
  editAddressModalOpen(address) {
    const newAddress = {
      ...address,
      // Address: address.Street.split(',')[0],
      // apartment: address.Street.split(',')[1],
    }
    this.addressForm = newAddress;
    this.$refs['addressForm'] && this.$refs['addressForm'].clearValidate();
    this.dialogVisible = true;
  },
  newAddressAdd() {
    this.resetForm();
    this.$refs['addressForm'] && this.$refs['addressForm'].clearValidate();
    this.dialogVisible = true;
  }
 },
 mounted() {
   this.fetchAddresses();
 },
//  computed: mapState({
//   addresses: state => state.addresses.customerDetails
//  }),
}
</script>

<style lang="less">
// @import "../../assets/css/profile.less";
.address_container {
 // border: 3px solid red;
 padding: 5% 5%;

 @media only screen and (max-width: 1000px) {
  .el-message-box--center {
   width: 90% !important;
  }
 }

 .fieldset {
  padding: 33px 25px;

  .el-input__inner {
    color: #000000;
    border: 1px solid #949494;
    border-radius: 0;
  }

  input::-webkit-input-placeholder {
   // color: #000000;
  }

  input::-ms-input-placeholder {
   // color: #000000;
  }

  .place {
   width: 100%;
   height: 40px;
   display: flex;
   justify-content: center;
   align-items: center;
   padding: 0;
   margin-top: 50px;
  }

  .btn {
   cursor: pointer;
   // display: block;
   background-color: #1D2A70;
   background-clip: border-box;
   box-sizing: border-box;
   border: 1px transparent solid;
   border-radius: 5px;
   color: white;
   font-weight: 500;
   padding: 15px;
   text-align: center;
   position: relative;
   transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
   float: right;
  }

  .btnCancel {
   cursor: pointer;
   display: inline-block;
   background-color: transparent;
   background-clip: border-box;
   box-sizing: border-box;
   border: 1px transparent solid black;
   border-radius: 5px;
   color: black;
   font-weight: 500;
   padding: 15px;
   text-align: center;
   position: relative;
   font-size: 14px;
   transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  }
 }

 .header_container {
  border-bottom: 1px solid silver;
  padding-bottom: 12px;
 }

 .address_body_container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 1000px) {
   .address_list {
    .el-dialog {
     width: 90%
    }
   }
  }

  // border:
  .title {
   display: flex;
   justify-content: center;
   align-items: center;
   padding: 10px 0;
   color: white;
   background: #1D2A70;
   border: 1px solid #1D2A70;
   cursor: pointer;

   span {
    font-weight: 700;
   }

   i {
    margin-right: 10px;
   }
  }
 }

 .modal {
  margin-top: 100px;
 }

 .dialog-footer {
  display: block;
  // flex-direction: row;
  // height:30px;
  // .btn_submit {
  //   float: right;
  // }
 }

 button {
  outline: none;
 }

 .time_tip {
  color: #1D2A70;
  font-size: 12px;
  // margin-left: 10px;
 }

 .address-container {
  display: flex;
  flex-direction: column;
  padding: 1em;
  border-radius: 0.2em;
  border: 1px solid #1D2A70;
  border-top: none;

  @media only screen and (max-width: 1000px) {
   .addressDisplay {
    display: block;
   }
  }

  .next-line {
   white-space: initial;
   display: inline-flex;
  }
 }

 ul {
  li {
   display: block;
   line-height: 30px;

   .deleteBtn {
    float: right;
   }

   .editBtn {
    float: right;
   }

   i {
    font-size: 20px;
    padding: 5px;
    cursor: pointer;
   }

   i:hover {
    color: #1D2A70;
    // background: #1D2A70;
    // background-color: red;
   }

  }
 }

 .greybackground {
  background-color: grey !important;
 }
}
</style>



// WEBPACK FOOTER //
// src/view/Profile/address.vue